import './map.scss';

/**
 * version    1.4
 * class      map
 */
export class Map {
  constructor() {
    this.items = document.querySelectorAll('.map__item');
    this.markers = document.querySelectorAll('.map__marker');
    this.popup = document.getElementById('map-popup');

    if (!this.popup) return;

    this.popupTitle = this.popup.querySelector('.map__popup-title');
    this.popupAddress = this.popup.querySelector('.map__popup-address');
    this.popupContact = this.popup.querySelector('.map__popup-contact');
    this.popupPhone = this.popup.querySelector('.map__popup-phone');
    this.popupEmailWrap = this.popup.querySelector('.map__popup-email');
    this.popupEmail = this.popup.querySelector('.map__popup-email-link');
    this.popupHours = this.popup.querySelector('.map__popup-hours');
    this.popupText = this.popup.querySelector('.map__popup-text');
    this.copyBtn = this.popup.querySelector('.map__copy-email');
    this.closeBtn = this.popup.querySelector('.map__popup-close');
    this.backBtn = this.popup.querySelector('.map__popup-back');
    this.data = window.MAP_DATA || {};

    this.bindEvents();
  }

  ensurePopupInViewport() {
    if (window.innerWidth < 992) return;

    const rect = this.popup.getBoundingClientRect();
    const offset = 300;

    // fuori sopra
    if (rect.top < 0) {
      window.scrollBy({
        top: rect.top - offset,
        behavior: 'smooth',
      });
    }

    // fuori sotto
    if (rect.bottom > window.innerHeight) {
      window.scrollBy({
        top: rect.bottom - window.innerHeight + offset,
        behavior: 'smooth',
      });
    }
  }

  bindEvents() {
    this.items.forEach((item) => {
      const open = () => {
        const { id } = item.dataset;
        const marker = this.getMarkerById(id);
        this.openPopup(id, marker || item);
      };

      // click
      item.addEventListener('click', open);

      // tastiera (ENTER + SPACE)
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open();
        }
      });
    });

    this.markers.forEach((marker) => {
      marker.addEventListener('click', (e) => {
        e.stopPropagation();
        this.openPopup(marker.dataset.id, marker);
      });
    });

    this.closeBtn.addEventListener('click', () => this.closePopup());
    this.backBtn.addEventListener('click', () => this.closePopup());

    document.addEventListener('click', (e) => {
      const isMarker = e.target.closest('.map__marker');
      const isItem = e.target.closest('.map__item');

      if (!this.popup.contains(e.target) && !isMarker && !isItem) {
        this.closePopup();
      }
    });

    this.copyBtn.addEventListener('click', () => this.copyEmail());
  }

  getMarkerById(id) {
    return document.querySelector(`.map__marker[data-id="${id}"]`);
  }

  openPopup(id, element) {
    const data = this.data[id];
    if (!data) {
      return;
    }

    // contenuti
    this.popupTitle.textContent = data.title || '';
    this.popupAddress.textContent = data.address || '';
    this.popupPhone.textContent = data.phone || '';
    this.popupEmail.textContent = data.email || '';
    this.popupEmail.href = data.email ? `mailto:${data.email}` : '#';
    this.popupHours.textContent = data.hours || '';
    this.popupText.innerHTML = data.text || '';

    // mostra/nasconde i contenitori in base alla presenza dei campi
    this.popupTitle.hidden = !data.title;
    this.popupAddress.hidden = !data.address;
    this.popupPhone.hidden = !data.phone;
    this.popupEmailWrap.hidden = !data.email;
    this.popupContact.hidden = !data.phone && !data.email;
    this.popupHours.hidden = !data.hours;
    this.popupText.hidden = !data.text;

    $('body').addClass('modal-open');

    this.popup.classList.remove('map__popup--left', 'map__popup--right');

    if (element && element.classList.contains('map__marker')) {
      const rect = element.getBoundingClientRect();
      const parent = element.offsetParent || element.closest('.map__canvas');
      const parentRect = parent.getBoundingClientRect();

      this.popup.style.top = '0px';
      this.popup.style.left = '0px';
      this.popup.classList.add('map__popup--visible');

      const popupRect = this.popup.getBoundingClientRect();

      const markerTop = rect.top - parentRect.top;
      const markerLeft = rect.left - parentRect.left;
      const markerCenterY = markerTop + rect.height / 2;

      const canvasWidth = parentRect.width;
      const offset = 12;

      let top = markerCenterY - popupRect.height / 2;
      let left;

      const spaceRight = canvasWidth - (markerLeft + rect.width);

      if (spaceRight > popupRect.width + offset) {
        left = markerLeft + rect.width + offset;
        this.popup.classList.add('map__popup--right');
      } else {
        left = markerLeft - popupRect.width - offset;
        this.popup.classList.add('map__popup--left');
      }

      top = Math.max(10, Math.min(top, parentRect.height - popupRect.height - 10));

      this.popup.style.top = `${top}px`;
      this.popup.style.left = `${left}px`;

      let arrowOffset = markerCenterY - top;
      arrowOffset = Math.max(16, Math.min(arrowOffset, popupRect.height - 16));

      this.popup.style.setProperty('--arrow-offset', `${arrowOffset}px`);
    }

    this.popup.classList.add('map__popup--visible');
    this.setActive(id);

    requestAnimationFrame(() => {
      this.ensurePopupInViewport();
    });
  }

  closePopup() {
    this.popup.classList.remove(
      'map__popup--visible',
      'map__popup--left',
      'map__popup--right',
    );
    $('body').removeClass('modal-open');
    this.clearActive();
  }

  setActive(id) {
    this.clearActive();

    document.querySelectorAll(`[data-id="${id}"]`).forEach((el) => {
      el.classList.add('map__item--active');
    });
  }

  clearActive() {
    document
      .querySelectorAll('.map__item--active')
      .forEach((el) => el.classList.remove('map__item--active'));
  }

  copyEmail() {
    const email = this.popupEmail.textContent;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(email);
    } else {
      const input = document.createElement('input');
      input.value = email;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    }
  }
}
